export default __webpack_public_path__ + "static/media/banner_1.2.db75dea1.svg";